<template>
  <main>
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <section class="flex h-full flex-col overflow-hidden" v-if="showError">
      <div class="flex-1 overflow-hidden py-6">
        <div class="subtitle-register px-2">
          <h1 class="text-md font-medium text-gray-600"><b>{{ participant.name }},</b></h1>
        </div>
        <div class="subtitle-register px-2 mt-5">
          <h1 class="text-sm font-bold text-red-600">AÇÃO NÃO PERMITIDA!</h1>
        </div>
        <div class="py-4 px-2 mt-4 bg-red-300 border-2 border-red-500 rounded-lg ml-2 mr-2">
          <div class="px-2">
            <h1 class="text-sm font-normal mb-1 text-red-900">Identificamos que você já enviou a confirmação do bilhete aéreo e termos de compromisso.</h1>
            <p class="mt-4 text-sm text-red-900">Qualquer dúvida, você pode entrar em contato conosco através do email <b>arcosuporte@fluireventos.com.br</b> ou através do nosso número de <b>Whatsapp (11) 98899-9900</b></p>
          </div>
        </div>
      </div>
    </section> 
    <section class="flex h-full flex-col" v-if="showAereoTermo">
      <form @submit.prevent="submitAereoTermo" class="form" autocomplete="off">
        <div class="flex-1 py-6 px-2">
          <div class="subtitle-register mb-10">
            <h1 class="text-md font-medium text-gray-600"><b>{{ participant.name }},</b></h1>
            <h1 class="mt-5 text-sm">Para finalizar a sua inscrição, agora precisamos que você confirme os próximos passos.</h1>
          </div>

          <div class="mt-4" v-if="participant.type_transport !== 'Avião'">
            <div class="mb-2 text-sm font-semibold">Qual horário estimado da sua chegada na quinta-feira, 07 de agosto? *</div>
            <div class="relative" :class="{ 'invalid-select': submitted && $v.form.arrived_time_bus_car.$error }" style="width: 100%">
              <multiselect
                tag-placeholder="Selecione"
                placeholder="Selecione"
                v-model="form.arrived_time_bus_car"
                select-label="Selecione uma opção"
                selectedLabel="Selecionado"
                deselectLabel="Desmarcar"
                label="label"
                track-by="label"
                class="text-gray-900 text-sm focus:outline-none focus:ring-1 focus:ring-gray-200"
                :options="[{label: '11h às 11h30', value: '11h às 11h30'}, {label: '11h30 às 12h', value: '11h30 às 12h'}, {label: '12h às 12h30', value: '12h às 12h30'}]"
                :multiple="false">
              </multiselect>
            </div>
          </div>
          <span  v-if="participant.type_transport === 'Avião'">
            <div class="mt-4">
              <div class="mb-2 text-sm font-semibold">Qual o aeroporto da sua chegada na quinta-feira, 07 de agosto? *</div>
              <div class="relative" :class="{ 'invalid-select': submitted && $v.form.arrived_airport.$error }" style="width: 100%">
                <multiselect
                  tag-placeholder="Selecione"
                  placeholder="Selecione"
                  v-model="form.arrived_airport"
                  select-label="Selecione uma opção"
                  selectedLabel="Selecionado"
                  deselectLabel="Desmarcar"
                  label="label"
                  track-by="label"
                  class="text-gray-900 text-sm focus:outline-none focus:ring-1 focus:ring-gray-200"
                  :options="[
                    {label: 'Aeroporto Internacional de Viracopos (VCP) – Campinas', value: 'Aeroporto Internacional de Viracopos (VCP) – Campinas'},
                    {label: 'Aeroporto  Internacional de Guarulhos (GRU) – São Paulo', value: 'Aeroporto  Internacional de Guarulhos (GRU) – São Paulo'},
                    {label: 'Aeroporto de Congonhas  (CGH) – São Paulo', value: 'Aeroporto de Congonhas  (CGH) – São Paulo'}
                  ]"
                  :multiple="false">
                </multiselect>
              </div>
            </div>
           </span>
            <div class="relative mt-4" style="width:100%" v-if="participant.type_transport === 'Avião'">
              <div class="mb-2 text-sm font-semibold">Horário estimado da sua chegada no dia 07 de agosto *</div>
                <input id="arrived_time"
                  v-model="form.arrived_time_flight"
                  type="time"
                  class="bg-white border border-gray-300 text-gray-900 text-sm rounded-md block w-full  p-4 focus:outline-none focus:ring-1 focus:ring-gray-200"
                  :class="{ 'border-red-500': submitted && $v.form.arrived_time_flight.$error }"
                  >
              </div>
            <span  v-if="participant.type_transport !== 'Carro'">
              <div class="mt-4">
                <h1 class="text-sm font-bold text-gray-600">Anexe aqui suas passagens de ida e volta *</h1>
              </div>
              <div class="py-4 mt-4 bg-white border-dashed border-2 border-gray-300 rounded-lg cursor-pointer" @click="showFile">
                <div class="px-2 py-4 flex justify-center" v-if="!aereoFile">
                  <svg width="48" height="48" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13 21H3.6C3.26863 21 3 20.7314 3 20.4V3.6C3 3.26863 3.26863 3 3.6 3H20.4C20.7314 3 21 3.26863 21 3.6V13" stroke="currentColor"  stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M3 16L10 13L15.5 15.5" stroke="currentColor"  stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M16 10C14.8954 10 14 9.10457 14 8C14 6.89543 14.8954 6 16 6C17.1046 6 18 6.89543 18 8C18 9.10457 17.1046 10 16 10Z" stroke="currentColor"  stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M16 19H19M22 19H19M19 19V16M19 19V22" stroke="currentColor"  stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <p class="text-center text-xs font-medium mt-2 text-green-600" v-if="aereoFile">{{ aereoFile.name }}</p>
                <p class="text-center text-xs font-medium mt-2" v-if="!aereoFile">Clique aqui e anexe as suas passagens</p>
                <p class="text-center text-xs font-normal mt-1" v-if="!aereoFile">PDF, JPG ou PNG</p>
                <input
                  ref="aereo"
                  type="file"
                  class="hidden"
                  name="aereo"
                  accept="*/*"
                  @change="setImage"
                />
              </div>
            </span>
          <!-- <h1 class="text-sm font-normal text-red-600 mt-2"><b>Importante:</b> Bilhete deve ser enviado em até 5 dias; após o prazo, sua inscrição será cancelada.</h1> -->
         
          <div class="flex mb-6 mt-6 items-center">
            <label for="authorizes_data_usage" class="ml-2 text-sm font-normal text-gray-500">Ao clicar em <b>CONCLUIR</b> eu declaro que li e concordo com os termos de compromisso</label>
          </div>
          <div class="absolute inset-x-0 bottom-10 p-3">
            <div class="next-form py-3 mt-5">
              <button
                type="submit"
                class="flex items-center justify-center w-full h-12 text-white font-semibold text-md uppercase transition-colors duration-150 bg-175376 rounded-lg focus:shadow-outline">
                <span class="flex justify-center mr-2">CONCLUIR</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="feather feather-arrow-right">
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </form>
    </section>
    <section class="flex justify-center" v-if="showThanks">
      <div class="w-full sm:w-full lg:w-full xl:w-full pt-10">
        <div class="px-2 pt-2">
          <div class="flex justify-center mb-4">
            <img class="max-h-44 max-w-60 rounded-lg" src="../assets/sucess.png">
          </div>
          <div class="tittle mb-2 px-4 text-center">
            <h1 class="text-3259ce text-md font-bold mb-4">{{ participant.name }},</h1>
            <h1 class="text-616161 text-sm font-semibold">Parabéns! Sua inscrição foi concluída com sucesso. Em breve, você receberá seu QR CODE de acesso e orientações gerais do evento.</h1>
          </div>
          <div class="py-2 mt-12 bg-white border-2 border-gray-200 rounded-lg">
            <div class="mb-2 text-center px-4">
              <h1 class="text-616161 text-sm font-bold mb-4">I M P O R T A N T E</h1>
              <h1 class="text-616161 text-sm font-normal">Fique atento ao seu e-mail de inscrição, pois é por meio dele que você receberá todas as informações necessárias.</h1>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import {VueMaskDirective} from 'maska'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/css/index.css'
import {sendAereoFile} from "@/services/api/register";
import {notification} from "@/services/notification";
import { required } from '@vuelidate/validators'
import Multiselect from '@vueform/multiselect'

export default {
  name: "aereo-termo",
  props: {
    participant: {
      type: Object,
      required: true,
    },
  },
  components: { Loading, Multiselect },
  directives: {
    mask: VueMaskDirective
  },
  data: () => ({
    open: false,
    mask: ['(', /\d/, /\d/, ') ', /\d?/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    loading: true,
    submitted: false,
    showAereoTermo: true,
    showError: false,
    showThanks: false,
    aereoFile: null,
    cupomRandom: ((Math.random() + 1).toString(36).substring(8)).toUpperCase(),
    form: {}
  }),
  validations() {
    let valid = {}
    if (this.participant.type_transport === 'Avião') {
       valid = {
        arrived_time_flight: { required },
        arrived_airport: { required }
      }
    }

    if (this.participant.type_transport !== 'Avião') {
      valid = {
        arrived_time_bus_car: { required }
      }
    }
    
    return { form: valid }
  },
  mounted () {
    this.loading = false;
    if (this.participant.status !== 2 || this.participant.ref_status !== 3 ) {
      this.showError = true;
      this.showPayment = false;
      this.$emit('headerDrawer', 'FALHA AO CONFIRMAR');
    }
  },
  computed: {
    rows () {
      return this.pagination.total
    }
  },
  methods: {
    showFile () {
      this.$refs.aereo.click()
    },
    setImage(e) {
      const file = e.target.files[0];
      const allowedExtensions = ['pdf', 'png', 'jpg', 'jpeg']; // Lista de extensões permitidas
      // Verificar se o tipo do arquivo é uma imagem ou se a extensão está na lista permitida
      if (!allowedExtensions.includes(file.name.split('.').pop().toLowerCase())) {
        // errorMessage('Alerta: Por favor selecione uma imagem, PDF, PNG ou JPG.');
        notification.error('Atenção: adicione apenas arquivos do tipo: PDF,JPG ou PNG');
        return;
      }

      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        notification.error('Atenção: Tamanho máximo 5MB');
        return;
      }

      if (typeof FileReader === 'function') {
        this.aereoFile = file;
      } else {
        notification.error('Atenção: Navegador não suporta filereader');
      }
    },
    stepTwo () {
      this.loading = true;
      setTimeout(() => {
        this.$emit('headerDrawer', 'INSCRIÇÃO - ENVIO DE DOCUMENTOS');
        this.showPayment = !this.showPayment;
        this.showAereoTermo = true;
        this.loading = false;
      }, "1000");

    },
    async submitAereoTermo () {
      try {
        this.loading = true;
        let resp;
        this.submitted = true
        this.loading = true;

        this.$v.form.$touch()

        if (this.$v.form.$invalid) {
          this.loading = false;
          return
        }

        if (!this.aereoFile && this.participant.type_transport !== 'Carro') {
          notification.error('Atenção: Você precisa seleciona as passagens, para continuar.');
          this.loading = false;
          return
        }
        const formData = new FormData()
        formData.append('id', this.participant.id)
        if (this.participant.type_transport !== 'Avião') {
          formData.append('arrived_time_bus_car', this.form.arrived_time_bus_car.value)
        }
        
        if (this.participant.type_transport === 'Avião') {
          formData.append('arrived_time_flight', this.form.arrived_time_flight)
          formData.append('arrived_airport', this.form.arrived_airport.value)
        }

        if (this.aereoFile) {
          let ext = this.aereoFile.type.split('/')[1]
          formData.append('aereoFile', this.aereoFile, 'aereoFile.' + ext)
        }
        resp = await sendAereoFile(formData);
        if (resp.upload) {
          this.$emit('headerDrawer', 'INSCRIÇÃO CONCLUÍDA');
          this.showAereoTermo = false;
          this.showThanks = true;
        }
        this.loading = false;
      } catch (err) {
        notification.error(err?.errMsg ?? 'Houve um problema para concluir inscrição');
        this.loading = false;
        return;
      }
    }
  },
}
</script>

<style scoped>
.i-file {
  margin-bottom: 1rem;
  max-width: 520px;
}

.c-s {
  margin-top: 2.5rem;
}
.bg-inactive {
  background: #ededed;
}
</style>
